module.exports = __webpack_public_path__ + "static/img/third2_1_2.22fe9993.jpg";